module.exports = __webpack_public_path__ + "img/QD.20b2b104.svg";